import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Heart, Menu, X } from "lucide-react";
import { NAV_LINKS, TRUST } from "@/content";

export const scrollToId = (id) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(`#${id}`, { offset: -72 });
  } else {
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  }
};

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 bg-cream/80 backdrop-blur-md border-b border-stone-200"
    >
      <nav className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between gap-4">
        <button
          data-testid="nav-logo-button"
          onClick={() => scrollToId("top")}
          className="flex items-center gap-3 shrink-0"
        >
          <img
            src="/logo.jpeg"
            alt="શ્રી યુનિક વિકલાંગ ચેરિટેબલ ટ્રસ્ટ લોગો"
            className="w-10 h-10 rounded-full object-cover bg-white ring-2 ring-leaf/30"
          />
          <span className="font-head font-bold text-ink text-base sm:text-lg leading-tight text-left">
            શ્રી યુનિક વિકલાંગ
            <span className="block text-xs font-medium text-leaf tracking-wide">
              ચેરિટેબલ ટ્રસ્ટ
            </span>
          </span>
        </button>

        <div className="hidden lg:flex items-center gap-7">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-link-${l.id}`}
              onClick={() => scrollToId(l.id)}
              className="font-head font-semibold text-sm text-ink/70 hover:text-saffron transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="nav-donate-button"
            onClick={() => scrollToId("donate")}
            className="flex items-center gap-2 rounded-full bg-saffron px-5 py-2.5 font-head font-bold text-sm text-cream shadow-[0_8px_30px_rgb(230,126,34,0.35)] hover:bg-saffron-dark hover:-translate-y-0.5 transition-all duration-200"
          >
            <Heart className="w-4 h-4" fill="currentColor" />
            દાન કરો
          </button>
        </div>

        <button
          data-testid="nav-mobile-menu-button"
          className="lg:hidden p-2 text-ink"
          onClick={() => setOpen(!open)}
          aria-label="મેનૂ"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </nav>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="nav-mobile-menu"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden overflow-hidden bg-cream/95 backdrop-blur-md border-b border-stone-200"
          >
            <div className="px-6 py-4 flex flex-col gap-4">
              {NAV_LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-mobile-link-${l.id}`}
                  onClick={() => {
                    setOpen(false);
                    scrollToId(l.id);
                  }}
                  className="text-left font-head font-semibold text-ink/80"
                >
                  {l.label}
                </button>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
